// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateEmissionsPartSearchCriteria = (state, action) => action.partNumber;

const resetEmissionsPartSearchCriteria = () => getDefaultState().partNumberSearchCriteria;

export default (state = getDefaultState().partNumberSearchCriteria, action) => {

    const actionTypes = {
        [actions.UPDATE_EMISSIONS_PART_SEARCH_CRITERIA]: updateEmissionsPartSearchCriteria,
        [actions.RESET_EMISSIONS_PART_SEARCH_REPORT]: resetEmissionsPartSearchCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/reducers/criteria.js